// extracted by mini-css-extract-plugin
export default {"container":"RenderEcmRichText-module_container__GyZec"};